import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { SecGroupRelationDescriptor } from './model/secgroup.relation';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class SecGroupRelationService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'SecGroupRelationManagement',
      authService,
      config.SGMSConfig
    );
  }

  public create(secGroupRelation: SecGroupRelationDescriptor): Promise<SecGroupRelationDescriptor> {
    return super.post<SecGroupRelationDescriptor>(
      new SecGroupRelationDescriptor({
        id: undefined,
        href: undefined,
        secGroupId: secGroupRelation.secGroupId,
        relatedObjectId: secGroupRelation.relatedObjectId,
        relatedObjectType: secGroupRelation.relatedObjectType,
        validFrom: secGroupRelation.validFrom,
        validUntil: secGroupRelation.validUntil,
        modified: secGroupRelation.modified,
        deleted: secGroupRelation.deleted
      }));
  }

  public getSecGroupRelations(view?: View): Promise<List<SecGroupRelationDescriptor>> {
    return super.get<List<SecGroupRelationDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, secGroupRelation: SecGroupRelationDescriptor): Promise<SecGroupRelationDescriptor> {
    return super.put<SecGroupRelationDescriptor>(id, secGroupRelation);
  }

  public getById(id: string): Promise<SecGroupRelationDescriptor> {
    return super.get<SecGroupRelationDescriptor>(id);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/secgroup.relation/secgroup.relation.service.ts